var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.195 19.4351L17.6263 20.0351C17.6263 20.0351 16.2725 21.4588 12.5788 17.5701C8.885 13.6813 10.2388 12.2576 10.2388 12.2576L10.5975 11.8788C11.48 10.9488 11.5638 9.45631 10.7925 8.36631L9.2175 6.13756C8.2625 4.78756 6.41875 4.61006 5.325 5.76131L3.36375 7.82506C2.8225 8.39631 2.46 9.13506 2.50375 9.95631C2.61625 12.0563 3.51375 16.5726 8.51875 21.8438C13.8275 27.4313 18.8088 27.6538 20.845 27.4526C21.49 27.3901 22.05 27.0413 22.5013 26.5663L24.2763 24.6963C25.4763 23.4338 25.1388 21.2713 23.6038 20.3888L21.2163 19.0138C20.2088 18.4351 18.9825 18.6051 18.195 19.4338",
    fill: "#2280FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 15C22.6092 14.9998 23.9312 14.5565 25.0158 13.7373C26.1004 12.9182 26.8884 11.7678 27.2603 10.4605C27.6323 9.15328 27.568 7.76038 27.0772 6.49295C26.5864 5.22551 25.6957 4.15262 24.5403 3.43686C23.3849 2.72111 22.0276 2.4015 20.6742 2.52649C19.3208 2.65147 18.0451 3.21423 17.0403 4.12948C16.0355 5.04473 15.3564 6.26258 15.106 7.59847C14.8555 8.93436 15.0474 10.3155 15.6525 11.5325C15.7666 11.7536 15.7964 12.0086 15.7363 12.25L15.3638 13.6413C15.3269 13.779 15.3269 13.924 15.3638 14.0618C15.4008 14.1995 15.4733 14.3251 15.5741 14.4259C15.6749 14.5268 15.8005 14.5993 15.9383 14.6362C16.076 14.6731 16.221 14.6731 16.3588 14.6363L17.75 14.2638C17.9914 14.2037 18.2464 14.2334 18.4675 14.3475C19.3322 14.777 20.2846 15.0003 21.25 15Z",
    fill: "#1D96FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7H25M22.3077 11H18",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponse);
export default __webpack_public_path__ + "static/media/Response.4cbdb58151f7e9f4db9cebb3c9be5cb9.svg";
export { ForwardRef as ReactComponent };